var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Logo_Coordinadora_blanco",
    "data-name": "Logo Coordinadora blanco",
    xmlns: "http://www.w3.org/2000/svg",
    width: 137.871,
    height: 12.734,
    viewBox: "0 0 137.871 12.734",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Trazado_3957",
    "data-name": "Trazado 3957",
    d: "M-968.433,591.508a3.347,3.347,0,0,0-2.438-1.243,2.94,2.94,0,0,0-2.82,2.405,2.048,2.048,0,0,0,2.123,2.406,4.211,4.211,0,0,0,2.751-1.146l-.862,4.615a10.658,10.658,0,0,1-3.269.491,5.153,5.153,0,0,1-5.278-6.251,7.8,7.8,0,0,1,7.475-6.482,8.662,8.662,0,0,1,2.931.508Z",
    transform: "translate(978.308 -586.303)",
    fill: "#fff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Trazado_3958",
    "data-name": "Trazado 3958",
    d: "M-898.286,586.761h5.417c2.782,0,4.952,1.178,4.46,4.287a3.542,3.542,0,0,1-2.9,3.208l-.015.1a2.494,2.494,0,0,1,.636.737l2.049,4.01h-5.171l-1.337-3.961h-.082l-.627,3.961h-4.386Zm3.52,5.466h.311c.736,0,1.491-.115,1.636-1.031.15-.949-.5-1.064-1.272-1.064h-.343Z",
    transform: "translate(933.758 -586.564)",
    fill: "#fff"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Trazado_3959",
    "data-name": "Trazado 3959",
    d: "M-872.4,586.761h4.566c4.141,0,7.028,1.816,6.31,6.35a6.986,6.986,0,0,1-7.151,5.99h-5.679Zm3.115,8.641h.278a2.728,2.728,0,0,0,3-2.308c.275-1.734-.607-2.471-2.243-2.471h-.278Z",
    transform: "translate(918.988 -586.564)",
    fill: "#fff"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Trazado_3960",
    "data-name": "Trazado 3960",
    d: "M-843.164,586.761h4.484l-1.954,12.34h-4.484Z",
    transform: "translate(902.303 -586.564)",
    fill: "#fff"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "Trazado_3961",
    "data-name": "Trazado 3961",
    d: "M-830.318,586.761h4.3l2.942,6.841h.131c-.019-.056.707-6.841.707-6.841h4.288L-819.9,599.1h-4.288l-2.917-6.481h-.131s-.748,6.481-.748,6.481h-4.288Z",
    transform: "translate(894.973 -586.564)",
    fill: "#fff"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "Trazado_3962",
    "data-name": "Trazado 3962",
    d: "M-799.013,599.1h-4.746l6.243-12.34h4.959l2.448,12.34h-4.746l-.165-1.539h-3.388Zm3.67-4.468s-.223-3.241-.222-3.764h-.163l-1.414,3.764Z",
    transform: "translate(878.701 -586.564)",
    fill: "#fff"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    id: "Trazado_3963",
    "data-name": "Trazado 3963",
    d: "M-770.049,586.761h4.566c4.14,0,7.028,1.816,6.309,6.35a6.986,6.986,0,0,1-7.151,5.99H-772Zm3.116,8.641h.278a2.728,2.728,0,0,0,3-2.308c.274-1.734-.607-2.471-2.243-2.471h-.278Z",
    transform: "translate(860.58 -586.564)",
    fill: "#fff"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    id: "Trazado_3964",
    "data-name": "Trazado 3964",
    d: "M-728.843,592.7a7.636,7.636,0,0,1-7.827,6.334c-3.764,0-6.449-2.374-5.822-6.334a7.779,7.779,0,0,1,7.838-6.4c3.748,0,6.425,2.521,5.811,6.4m-9.142.064a1.872,1.872,0,0,0,1.932,2.373,2.706,2.706,0,0,0,2.683-2.373,1.906,1.906,0,0,0-1.927-2.406,2.763,2.763,0,0,0-2.689,2.406",
    transform: "translate(843.79 -586.302)",
    fill: "#fff"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    id: "Trazado_3965",
    "data-name": "Trazado 3965",
    d: "M-710.24,586.761h5.417c2.782,0,4.952,1.178,4.46,4.287a3.543,3.543,0,0,1-2.9,3.208l-.016.1a2.475,2.475,0,0,1,.636.737l2.049,4.01h-5.171l-1.337-3.961h-.082l-.627,3.961h-4.386Zm3.521,5.466h.311c.736,0,1.491-.115,1.636-1.031.15-.949-.5-1.064-1.271-1.064h-.344Z",
    transform: "translate(826.449 -586.564)",
    fill: "#fff"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    id: "Trazado_3966",
    "data-name": "Trazado 3966",
    d: "M-684.233,599.1h-4.746l6.242-12.34h4.958l2.448,12.34h-4.746l-.166-1.539h-3.387Zm3.67-4.468s-.223-3.241-.222-3.764h-.164l-1.414,3.764Z",
    transform: "translate(813.201 -586.564)",
    fill: "#fff"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    id: "Trazado_3967",
    "data-name": "Trazado 3967",
    d: "M-921.983,586.92a9.122,9.122,0,0,0-4.6,1.159c.13.176.266.308.4.486a4.685,4.685,0,0,1,.972,2.965c0,.084,0,.212,0,.3a2.933,2.933,0,0,1,2.214-1.011,1.746,1.746,0,0,1,1.773,2.334,3.024,3.024,0,0,1-2.922,2.31,1.833,1.833,0,0,1-1.72-.975A8.468,8.468,0,0,1-929,598.077a7,7,0,0,0,3.894,1.143c3.849-.008,7.559-2.263,8.53-6.072.921-3.759-1.6-6.19-5.4-6.229",
    transform: "translate(950.172 -586.653)",
    fill: "#fff"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    id: "Trazado_3968",
    "data-name": "Trazado 3968",
    d: "M-945.891,586.748a9.872,9.872,0,0,0-1.59.136,8.383,8.383,0,0,0-6.937,5.975c-.964,3.856,1.6,6.153,5.45,6.192a10.059,10.059,0,0,0,1.5-.137,8.2,8.2,0,0,0,6.984-5.941c.966-3.756-1.558-6.19-5.408-6.226m.8,6.237a3.035,3.035,0,0,1-2.385,2.258,3.307,3.307,0,0,1-.578.045,1.734,1.734,0,0,1-1.773-2.347,3.079,3.079,0,0,1,2.347-2.208,2.8,2.8,0,0,1,.62-.087,1.76,1.76,0,0,1,1.768,2.339",
    transform: "translate(964.791 -586.556)",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/Logo.44778395f39f380ab5ea9fe44216d0c3.svg";
export { ForwardRef as ReactComponent };